import React, { useState } from 'react';

import { Form, FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { svg } from '../assets/svg';
import { components } from '../components';
import { showSuccessToast } from '../components/Toast';
import { hooks } from '../hooks';
import { Routes } from '../routes';
import apiService from '../service/ApiService';
import kikininLogo from '../assets/icons/logo.png';
import utils from '../helpers/utils';

const validationSchema = yup.object({
  phone: yup
    .string()
    .required('Phone Number is required.')
    .min(10, 'Phone Number must be at least 10 digits.')
    .matches(/^[0-9]+$/, 'Phone number must only contain digits.'),
});

export const SignIn: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const formik = useFormik({
    initialValues: {
      phone: '',
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      setSubmitting(true);
      setIsSubmitting(true);
      const apiData = {
        phone: values.phone,
      };
      const { data, error } = await apiService.loginAsync(apiData);
      if (data) {
        showSuccessToast('OTP send successfully.');
        navigate(Routes.SendPhoneOtp, { state: { phoneNumber: values.phone, isLoggedIn: true } });
      } else if (error) {
        setErrors(error);
      }
      setSubmitting(false);
      setIsSubmitting(false);
    },
  });

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container' style={{ paddingTop: 20 }}>
        <FormikProvider value={formik}>
          <Form autoComplete='off' noValidate onSubmit={formik.handleSubmit}>
            <section
              style={{
                backgroundColor: 'var(--white-color)',
                paddingLeft: 20,
                paddingRight: 20,
                height: '95vh',
                paddingTop: '2%',
                borderRadius: 10,
              }}
            >
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 16, marginTop: 10 }}>
                <img src={kikininLogo} alt="Logo" style={{ width: 100, height: 100 }} />
              </div>
              <h1 style={{ marginBottom: 3 }}>Welcome Back!</h1>
              <span
                className='t16'
                style={{ marginBottom: 30, display: 'block' }}
              >
                Login to continue
              </span>
              <components.Input
                placeholder='Phone Number'
                name='phone'
                value={formik.values.phone}
                onChange={formik.handleChange}
                error={formik.errors.phone}
                touched={formik.touched.phone}
                leftIcon={<svg.PhoneSvg />}
                maxLength={10}
                inputMode={'numeric'}
                onKeyDown={utils.handleNumericKey}
              />
              <components.Button
                text='Login'
                containerStyle={{ marginBottom: 20 }}
                disabled={formik.isSubmitting}
              />
              <div style={{ gap: 4 }} className='row-center'>
                <span className='t14'>Don’t have an account?</span>
                <span
                  className='t14 clickable'
                  style={{ color: 'var(--main-turquoise)' }}
                  onClick={() => {
                    navigate(Routes.SignUp);
                  }}
                >
                  Sign up.
                </span>
              </div>
            </section>
          </Form>
        </FormikProvider>
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (isSubmitting) return <components.Loader />;
    return null;
  };

  return (
    <div id='screen' style={{ opacity }}>
      {renderLoader()}
      {isSubmitting ? (
        <components.Loader />
      ) : (
        <>
          {renderContent()}
        </>
      )}
    </div>
  );
};
